// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1wHHg","footerInner":"styles_footerInner__3Lj45","footerContainer":"styles_footerContainer__4oCbo","productsSection":"styles_productsSection__of1Pj"};